// extracted by mini-css-extract-plugin
export default {"header":"action_header__iul2q","cohortName":"action_cohortName__YWnr8","dates":"action_dates__F3Ez9"};